import React, { useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
  CircularProgress,
  Alert,
} from '@mui/material';

const DynamicUploadModal = ({
  open,
  onClose,
  uploadPreset = 'bookMyDr', // Default Cloudinary upload preset
  folderName = 'default_folder', // Default folder name
  maxSize = 2 * 1024 * 1024, // Default max file size in bytes (2MB)
  onUploadSuccess, // Callback function after successful upload
}) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [error, setError] = useState(null);

  const handleFileChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      // Check for file size
      if (selectedFile.size > maxSize) {
        setError(`File size exceeds ${maxSize / (1024 * 1024)}MB`);
        setFile(null);
      } else {
        setFile(selectedFile);
        setError(null);
      }
    }
  };

  const handleUpload = async () => {
    if (!file) return;

    setLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', uploadPreset);
    formData.append('folder', folderName);

    try {
      const response = await fetch('https://api.cloudinary.com/v1_1/dbctfcooz/image/upload', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Image upload failed');
      }

      const data = await response.json();
      setImageUrl(data.secure_url);
      setFile(null);

      // Trigger the callback function if provided
      if (onUploadSuccess) {
        onUploadSuccess(data.secure_url);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => { onClose(); setImageUrl(null); }}>
      <DialogTitle>Upload Image</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please upload an image to get its URL.
        </DialogContentText>
        <input type="file" accept="image/*" onChange={handleFileChange} />
        {loading && <CircularProgress />}
        {imageUrl && (
          <div>
            <TextField
              margin="dense"
              label="Uploaded URL"
              type="text"
              fullWidth
              value={imageUrl}
              InputProps={{
                readOnly: true,
              }}
            />
            <img src={imageUrl} alt="Uploaded" style={{ width: '200px', marginTop: '10px' }} />
          </div>
        )}
        {error && <Alert severity="error">{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => { onClose(); setImageUrl(null); }} color="primary">
          Cancel
        </Button>
        <Button onClick={handleUpload} color="primary" disabled={loading || !file}>
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DynamicUploadModal;
